var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid fixed-top w-100 px-0",
          attrs: { id: "nav-info", role: "navigation" }
        },
        [_c("interview-navi", { attrs: { navData: _vm.pageData } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "quote-panel-open": _vm.quotePanelStatus,
            "quote-panel-close": !_vm.quotePanelStatus
          },
          attrs: { role: "main" }
        },
        [
          _c("form-notifications", { attrs: { pageData: _vm.pageData } }),
          _vm._v(" "),
          _vm.blurbs.formtop && _vm.blurbs.formtop.visible
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center mx-auto mb-1" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "alert alert-primary my-0 py-2 w-50",
                      attrs: { role: "note" }
                    },
                    [
                      _c("div", { staticClass: "row no-gutters" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", {
                          staticClass:
                            "col d-inline-block my-auto smaller-font-content",
                          domProps: {
                            innerHTML: _vm._s(_vm.blurbs.formtop.content)
                          }
                        })
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters mx-0" }, [
            _c("div", { staticClass: "col-12" }, [
              _vm.pageData.Error && this.pageData.fields !== null
                ? _c("div", { staticClass: "alert alert-danger" }, [
                    _c(
                      "div",
                      {
                        staticClass: "my-0 py-2 w-100",
                        attrs: { role: "alert" }
                      },
                      [
                        _c("div", { staticClass: "row no-gutters" }, [
                          _c(
                            "div",
                            { staticClass: "d-inline-block pr-2 my-auto" },
                            [
                              _c("icon", {
                                staticClass: "alert-icon",
                                attrs: { name: "info-circle", scale: "1.0" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col d-inline-block my-auto",
                              attrs: { "aria-level": "3" }
                            },
                            [
                              _c("strong", [_vm._v("Carrier Rating Error: ")]),
                              _vm._v(
                                _vm._s(_vm.pageData.Error.Message) +
                                  "\n              "
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.pageData.fields === null
                ? _c("div", { staticClass: "row", attrs: { id: "errorMsg" } }, [
                    _vm._m(1)
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "needs-validation",
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.submitted($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-row mx-0" }, [
                    _c("div", { staticClass: "col-12 col-md-6 px-0" }, [
                      _vm.hasFields(_vm.colsArray[0], _vm.pageFieldsArray)
                        ? _c(
                            "div",
                            { staticClass: "mr-md-4 shadow-sm pb-2 rounded" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "py-2 pl-2 mt-1 text-white bg-ltblue rounded-top",
                                  attrs: { role: "heading", "aria-level": "3" }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.colsArray[0])
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mx-2 pt-2" },
                                _vm._l(_vm.pageFieldsArray, function(
                                  item,
                                  key
                                ) {
                                  return item.section === _vm.colsArray[0]
                                    ? _c("form-block", {
                                        key: key,
                                        staticClass: "form-group",
                                        attrs: { formdata: item }
                                      })
                                    : _vm._e()
                                }),
                                1
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-6 px-0" }, [
                      _c("div", { staticClass: "ml-md-4 pb-2" }, [
                        _vm.hasFields(
                          "PIP Medical Expense Details",
                          _vm.pageFieldsArray
                        ) && _vm.pipMedExp[0].visible == true
                          ? _c(
                              "div",
                              { staticClass: "shadow-sm pb-2 mb-3 rounded" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "w-100" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "py-2 pl-2 text-white bg-ltblue rounded-top",
                                        attrs: {
                                          role: "heading",
                                          "aria-level": "3"
                                        }
                                      },
                                      [_vm._v("PIP Medical Expense Details")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "mx-2 pt-2" },
                                      _vm._l(_vm.pageFieldsArray, function(
                                        item,
                                        key
                                      ) {
                                        return item.section ===
                                          "PIP Medical Expense Details" &&
                                          item.sub_section === ""
                                          ? _c("form-block", {
                                              key: key,
                                              staticClass: "form-group",
                                              attrs: { formdata: item }
                                            })
                                          : _vm._e()
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.pipMedExpSubSec, function(
                                      pmitem,
                                      pmkey
                                    ) {
                                      return _c("div", { key: pmkey }, [
                                        pmitem[0].visible == true
                                          ? _c(
                                              "div",
                                              { staticClass: "mx-3 mt-3" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "py-2 pl-2 mt-1 text-white bg-ltblue"
                                                  },
                                                  [_vm._v(_vm._s(pmkey))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mx-2 mr-3 pt-2 row "
                                                  },
                                                  _vm._l(pmitem, function(
                                                    imtem,
                                                    mkey
                                                  ) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: mkey,
                                                        staticClass: "mr-5"
                                                      },
                                                      [
                                                        _c("form-block", {
                                                          attrs: {
                                                            formdata: imtem
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  }),
                                                  0
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFields(_vm.colsArray[1], _vm.pageFieldsArray) &&
                        _vm.pipCoveHouseMem.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "mr-md-4 shadow-sm pb-2 rounded mb-3"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "py-2 pl-2 mt-1 text-white bg-ltblue rounded-top",
                                    attrs: {
                                      role: "heading",
                                      "aria-level": "3"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.colsArray[1])
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.pipCoveHouseMem, function(
                                  pitem,
                                  pkey
                                ) {
                                  return _c("div", { key: pkey }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pip-house-member mx-3 mt-3"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "py-2 pl-2 mt-1 text-white bg-pip-subheader"
                                          },
                                          [_vm._v(_vm._s(pitem[0].sub_section))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "mx-2 mr-3 pt-2 row "
                                          },
                                          _vm._l(pitem, function(item, key) {
                                            return _c(
                                              "div",
                                              { key: key, staticClass: "mr-5" },
                                              [
                                                _c("form-block", {
                                                  attrs: { formdata: item }
                                                })
                                              ],
                                              1
                                            )
                                          }),
                                          0
                                        )
                                      ]
                                    )
                                  ])
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFields(
                          "Error: Additional Household Member Found",
                          _vm.pageFieldsArray
                        ) && _vm.hasHouseholdMembers(_vm.pageFieldsArray)
                          ? _c("div", { staticClass: "shadow-sm pb-2 mb-3" }, [
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mx-2 pt-2" },
                                [
                                  _vm._l(_vm.additionalHousehold, function(
                                    item,
                                    key
                                  ) {
                                    return [
                                      _vm.newHeader(
                                        key,
                                        _vm.additionalHousehold
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              key: "header-key-" + key,
                                              staticClass:
                                                "pl-3 py-1 mb-1 subSection-header-auto",
                                              attrs: {
                                                role: "heading",
                                                "aria-level": "4"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(item.sub_section)
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("form-block", {
                                        key: "formblock-key-" + key,
                                        staticClass: "form-group",
                                        attrs: { formdata: item }
                                      })
                                    ]
                                  })
                                ],
                                2
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFields(
                          "Vehicle Mileage Reconciliation | Confirm the following with the customer",
                          _vm.pageFieldsArray
                        )
                          ? _c("div", { staticClass: "shadow-sm pb-2 mb-3" }, [
                              _vm._m(3),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mx-2 pt-2" },
                                [
                                  _vm._l(
                                    _vm.vehicleMileageReconciliationSubSections,
                                    function(
                                      vehicleMileageReconciliationSubSection,
                                      i
                                    ) {
                                      return [
                                        _vm.getFieldsFromSubSection(
                                          vehicleMileageReconciliationSubSection
                                        ).length
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  key: "key-" + i,
                                                  staticClass:
                                                    "pl-3 py-1 mb-1 subSection-header-auto",
                                                  attrs: {
                                                    role: "heading",
                                                    "aria-level": "4"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        vehicleMileageReconciliationSubSection
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.getFieldsFromSubSection(
                                                  vehicleMileageReconciliationSubSection
                                                ),
                                                function(subSectionField, j) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        key:
                                                          "key-" + i + "-" + j
                                                      },
                                                      [
                                                        _c("form-block", {
                                                          key:
                                                            "formblock-key-" +
                                                            i +
                                                            "-" +
                                                            j,
                                                          staticClass:
                                                            "form-group",
                                                          attrs: {
                                                            formdata: subSectionField
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              )
                                            ]
                                          : _vm._e()
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFields(
                          "Safeco Preliminary Report | Confirm the following with the customer",
                          _vm.pageFieldsArray
                        )
                          ? _c("div", { staticClass: "shadow-sm pb-2 mb-3" }, [
                              _vm._m(4),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mx-2 pt-2" },
                                _vm._l(_vm.pageFieldsArray, function(
                                  item,
                                  key
                                ) {
                                  return item.section ===
                                    "Safeco Preliminary Report | Confirm the following with the customer"
                                    ? _c("form-block", {
                                        key: key,
                                        staticClass: "form-group",
                                        attrs: { formdata: item }
                                      })
                                    : _vm._e()
                                }),
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFields(
                          "Missing Driver's License Number",
                          _vm.pageFieldsArray
                        )
                          ? _c("div", { staticClass: "shadow-sm pb-2 mb-3" }, [
                              _vm._m(5),
                              _vm._v(" "),
                              _vm._m(6),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "pl-3" },
                                [
                                  _vm._l(_vm.pageFieldsArray, function(
                                    item,
                                    key
                                  ) {
                                    return item.section ===
                                      "Missing Driver's License Number" &&
                                      item.visible == true
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              key: "header-key-" + key,
                                              staticClass:
                                                "py-1 pl-2 mt-1 bg-lt-blue dlv-heading",
                                              attrs: {
                                                role: "heading",
                                                "aria-level": "3"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(item.sub_section)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("form-block", {
                                            key: "formblock-key-" + key,
                                            staticClass: "form-group",
                                            attrs: { formdata: item }
                                          })
                                        ]
                                      : _vm._e()
                                  })
                                ],
                                2
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFields("Report Consent", _vm.pageFieldsArray)
                          ? _c("div", { staticClass: "shadow-sm pb-2 mb-3" }, [
                              _vm._m(7),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mx-2 pt-2" },
                                _vm._l(_vm.pageFieldsArray, function(
                                  item,
                                  key
                                ) {
                                  return item.section === "Report Consent"
                                    ? _c("form-block", {
                                        key: key,
                                        staticClass: "form-group",
                                        attrs: { formdata: item }
                                      })
                                    : _vm._e()
                                }),
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFields(
                          "Privacy Policy & MVR Reporting",
                          _vm.pageFieldsArray
                        )
                          ? _c(
                              "div",
                              { staticClass: "shadow-sm pb-2 mb-3 rounded" },
                              [
                                _c("div", { staticClass: "w-100" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "py-2 pl-2 text-white bg-ltblue rounded-top",
                                      attrs: {
                                        role: "heading",
                                        "aria-level": "3"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Privacy\n                      Policy & MVR Reporting"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mx-2 pt-2" },
                                    _vm._l(_vm.pageFieldsArray, function(
                                      item,
                                      key
                                    ) {
                                      return item.section ===
                                        "Privacy Policy & MVR Reporting"
                                        ? _c("form-block", {
                                            key: key,
                                            staticClass: "form-group",
                                            attrs: { formdata: item }
                                          })
                                        : _vm._e()
                                    }),
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFields(
                          "Policies & MVR Reporting",
                          _vm.pageFieldsArray
                        )
                          ? _c(
                              "div",
                              { staticClass: "shadow-sm pb-2 mb-3 rounded" },
                              [
                                _c("div", { staticClass: "w-100" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "py-2 pl-2 text-white bg-ltblue rounded-top",
                                      attrs: {
                                        role: "heading",
                                        "aria-level": "3"
                                      }
                                    },
                                    [_vm._v("Policies & MVR Reporting")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mx-2 pt-2" },
                                    _vm._l(_vm.pageFieldsArray, function(
                                      item,
                                      key
                                    ) {
                                      return item.section ===
                                        "Policies & MVR Reporting"
                                        ? _c("form-block", {
                                            key: key,
                                            staticClass: "form-group",
                                            attrs: { formdata: item }
                                          })
                                        : _vm._e()
                                    }),
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFields("Privay Policy", _vm.pageFieldsArray)
                          ? _c(
                              "div",
                              { staticClass: "shadow-sm pb-2 mb-3 rounded" },
                              [
                                _c("div", { staticClass: "w-100" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "py-2 pl-2 text-white bg-ltblue rounded-top",
                                      attrs: {
                                        role: "heading",
                                        "aria-level": "3"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Privacy\n                      Policy"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mx-2 pt-2" },
                                    _vm._l(_vm.pageFieldsArray, function(
                                      item,
                                      key
                                    ) {
                                      return item.section === "Privay Policy"
                                        ? _c("form-block", {
                                            key: key,
                                            staticClass: "form-group",
                                            attrs: { formdata: item }
                                          })
                                        : _vm._e()
                                    }),
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFields(
                          "Policy & MVR Reporting",
                          _vm.pageFieldsArray
                        )
                          ? _c(
                              "div",
                              { staticClass: "shadow-sm pb-2 mb-3 rounded" },
                              [
                                _c("div", { staticClass: "w-100" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "py-2 pl-2 text-white bg-ltblue rounded-top",
                                      attrs: {
                                        role: "heading",
                                        "aria-level": "3"
                                      }
                                    },
                                    [_vm._v("Policy & MVR Reporting")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mx-2 pt-2" },
                                    _vm._l(_vm.pageFieldsArray, function(
                                      item,
                                      key
                                    ) {
                                      return item.section ===
                                        "Policy & MVR Reporting"
                                        ? _c("form-block", {
                                            key: key,
                                            staticClass: "form-group",
                                            attrs: { formdata: item }
                                          })
                                        : _vm._e()
                                    }),
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasFields(
                          "Progressive Preliminary Report | Confirm the following with the customer.",
                          _vm.pgrPreliminaryPremiumFields
                        )
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "shadow-sm pb-2 mb-3 rounded" },
                                [
                                  _vm._m(8),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mx-2 pt-2" },
                                    _vm._l(
                                      _vm.pgrPreliminaryPremiumFields,
                                      function(item, key) {
                                        return _c("form-block", {
                                          key: key,
                                          staticClass: "form-group",
                                          attrs: { formdata: item }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "shadow-sm pb-2 mb-3 rounded" },
                                [
                                  _vm._m(9),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      ref: "driverIncidentsContent",
                                      staticClass: "pb-2",
                                      staticStyle: { display: "block" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row mx-0 mt-2" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "mx-2 pt-2" },
                                            [
                                              _vm._v(
                                                "\n                          The following consumer information was returned by the "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  ref: "reportAgency",
                                                  attrs: {
                                                    href: "JavaScript:void(0);",
                                                    id: "reportAgency",
                                                    name: "reportAgency"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.openReportingAgencyModal(
                                                        "reporting-agency-modal"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "consumer reporting agency"
                                                  )
                                                ]
                                              ),
                                              _vm._v(
                                                ". When updating your premium, we only use the reported items that are compliant with the insurance laws and regulations in your state.\n                        "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "modal",
                                        {
                                          attrs: {
                                            name: "reporting-agency-modal",
                                            height: "auto",
                                            scrollable: true
                                          },
                                          on: {
                                            opened: function($event) {
                                              return _vm.modalOpened(
                                                "reportAgency"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("Trap", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "breakdown-modal-top pt-2 pl-3 pr-2 bg-primary text-white"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticClass:
                                                      "breakdown-modal-header"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Consumer Reporting Agency Information"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    ref: "reportAgency",
                                                    staticClass:
                                                      "cursorBox fa-stack uniform-icon-breakdown",
                                                    attrs: {
                                                      href:
                                                        "JavaScript:void(0);",
                                                      id: "reportAgency",
                                                      name: "reportAgency"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.closeReportingAgencyModal(
                                                          "reporting-agency-modal"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "fas fa-circle fa-stack-2x",
                                                      staticStyle: {
                                                        color: "#fff"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "fas fa-times fa-stack-1x",
                                                      staticStyle: {
                                                        color: "#1C3664"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "mt-3 px-3",
                                                attrs: {
                                                  id: "reporting-agency-content"
                                                }
                                              },
                                              [
                                                _c("p", [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "Why Your Premium Has Been Updated"
                                                    )
                                                  ]),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Initially, your premium was based upon the information you provided to us when you first received your quote. As part of our verification process, we order driving records and claims history reports from a consumer reporting agency - this is normal in the insurance industry."
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _c("strong", [
                                                    _vm._v("LexisNexis")
                                                  ]),
                                                  _c("br"),
                                                  _vm._v(
                                                    "LexisNexis is an information provider, and is not responsible for the insurance company's decision to change your premium. They will not be able to provide specific reasons for the insurance company's decision."
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "How to Contact LexisNexis"
                                                    )
                                                  ]),
                                                  _c("br"),
                                                  _vm._v(
                                                    "If you have questions concerning the information in your consumer reports please contact LexisNexis directly. You can get a free copy of your report by contacting LexisNexis within 60 days."
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-center font-weight-bold text-primary",
                                                    attrs: {
                                                      id:
                                                        "consumer-disclosure-para-holder"
                                                    }
                                                  },
                                                  [
                                                    _vm._v("1-800-456-6004"),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "d-block",
                                                        attrs: {
                                                          id:
                                                            "consumer-disclosure-anchor",
                                                          href:
                                                            "https://www.consumerdisclosure.com/",
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "consumerdisclosure.com"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "w-100" },
                                        [
                                          _vm._m(10),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.finalDriversIncidents,
                                            function(item, key) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    key: key + "2",
                                                    staticClass:
                                                      "row mx-3 py-1 smaller-font-content incident-item"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col border-right font-weight-bold"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-2 border-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.type)
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-2 border-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.date)
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "col" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.description
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm.finalDriversIncidents &&
                                          _vm.finalDriversIncidents.length == 0
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "mt-2 mx-4 text-left smaller-font-content font-weight-bold",
                                                    attrs: {
                                                      id: "no-incidents-msg"
                                                    }
                                                  },
                                                  [_vm._v("No Incidents Found")]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _vm.blurbs.formbottom && _vm.blurbs.formbottom.visible
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center mx-auto mt-3"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "alert alert-primary my-0 py-2 w-50",
                              attrs: { role: "note" }
                            },
                            [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _vm._m(11),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass:
                                    "col d-inline-block my-auto smaller-font-content",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.blurbs.formbottom.content
                                    )
                                  }
                                })
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getContinueLabelName() != "" && _vm.continueEnabled
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "form-row justify-content-center mx-0 my-3"
                        },
                        [
                          _c("div", { staticClass: "col-8 text-center" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "submit" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.submitted($event)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.getContinueLabelName()))]
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("dev-auto-fill", { attrs: { pageData: _vm.pageData } }),
      _vm._v(" "),
      _vm.$store.state.buttonState.quoteSummaryData &&
      _vm.$store.state.buttonState.quoteSummaryData.quote_status === "Bound"
        ? _c("form-alerts", {
            class: {
              "policy-bound-alert": true,
              "margin-25": _vm.quotePanelStatus
            },
            attrs: { pageData: _vm.policyBindError }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-12 pt-3 pb-2 mb-3 text-white text-center bg-danger",
        attrs: { "aria-level": "3" }
      },
      [_c("h1", [_vm._v("We were unable to proceed due to an error.")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-table mt-1" }, [
      _c("div", { staticClass: "d-table-cell qrp-error-background  p-1" }, [
        _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
          _c("span", {
            staticClass: "fas fa-circle fa-stack-2x ",
            staticStyle: { color: "#BB0000" }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "fas fa-exclamation fa-stack-1x qrp-text-white"
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-table-cell w-100 pl-3 py-2 text-dark-gray  qrp-error-background",
          attrs: { role: "alert", "aria-atomic": "true" }
        },
        [_vm._v("Error: Additional Household Member Found")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-table mt-1" }, [
      _c("div", { staticClass: "d-table-cell qrp-error-background  p-1" }, [
        _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
          _c("span", {
            staticClass: "fas fa-circle fa-stack-2x ",
            staticStyle: { color: "#BB0000" }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "fas fa-exclamation fa-stack-1x qrp-text-white"
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-table-cell w-100 pl-3 py-2 text-dark-gray  qrp-error-background",
          attrs: { role: "alert", "aria-atomic": "true" }
        },
        [
          _vm._v(
            "Vehicle Mileage Reconciliation | Confirm the following with the customer"
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-table mt-1" }, [
      _c("div", { staticClass: "d-table-cell bg-yellow p-1" }, [
        _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
          _c("span", {
            staticClass: "fas fa-circle fa-stack-2x icon-incomplete"
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "fas fa-exclamation fa-stack-1x qrp-text-white"
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-table-cell w-100 pl-3 py-2 bg-yellow text-dark-gray",
          attrs: { role: "alert", "aria-atomic": "true" }
        },
        [
          _vm._v(
            "Safeco Preliminary Report | Confirm the following with the customer"
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-table mt-1" }, [
      _c("div", { staticClass: "d-table-cell qrp-error-background p-2" }, [
        _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
          _c("span", {
            staticClass: "fas fa-circle fa-stack-2x icon-incomplete",
            staticStyle: { color: "#BB0000" }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "fas fa-exclamation fa-stack-1x qrp-text-white"
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-table-cell w-100 pr-2 py-2 qrp-error-background text-dark-gray",
          attrs: { role: "alert", "aria-atomic": "true" }
        },
        [_vm._v("Missing Driver's License Number")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "msdl-content px-3" }, [
      _c("span", [
        _vm._v(
          "Our reports were unable to acquire the driver’s license number for the following applicants. Branch requires this information to complete the policy and run reports."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-table mt-1" }, [
      _c("div", { staticClass: "d-table-cell bg-yellow p-1" }, [
        _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
          _c("span", {
            staticClass: "fas fa-circle fa-stack-2x icon-incomplete"
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "fas fa-exclamation fa-stack-1x qrp-text-white"
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-table-cell w-100 pl-3 py-2 bg-yellow text-dark-gray",
          attrs: { role: "alert", "aria-atomic": "true" }
        },
        [_vm._v("Report Consent")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-table mt-1" }, [
      _c("div", { staticClass: "d-table-cell bg-yellow p-1" }, [
        _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
          _c("span", {
            staticClass: "fas fa-circle fa-stack-2x icon-incomplete"
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "fas fa-exclamation fa-stack-1x qrp-text-white"
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-table-cell w-100 pl-3 py-2 bg-yellow text-dark-gray",
          attrs: { role: "alert", "aria-atomic": "true" }
        },
        [
          _vm._v(
            "Progressive Preliminary Report | Confirm the following with the customer"
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-table mt-1" }, [
      _c("div", { staticClass: "d-table-cell bg-yellow p-1" }, [
        _c("span", { staticClass: "fa-stack uniform-icon-size" }, [
          _c("span", {
            staticClass: "fas fa-circle fa-stack-2x icon-incomplete"
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "fas fa-exclamation fa-stack-1x qrp-text-white"
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-table-cell w-100 pl-3 py-2 bg-yellow text-dark-gray",
          attrs: { role: "alert", "aria-atomic": "true" }
        },
        [_vm._v("Discovered Driver Incidents | CLUE Report")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "row mx-2 mt-2 py-1 smaller-font-content font-weight-bold bg-lt-blue text-dark-gray"
      },
      [
        _c("div", { staticClass: "col border-right" }, [_vm._v("Driver Name")]),
        _vm._v(" "),
        _c("div", { staticClass: "col-2 border-right" }, [_vm._v("Type")]),
        _vm._v(" "),
        _c("div", { staticClass: "col-2 border-right" }, [_vm._v("Date")]),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [_vm._v("Description")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28f6ff20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f6ff20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/Auto/RC2/PolicyDetails.vue
// module id = null
// module chunks = 